<template>
    <div class="project_statistical">
        <div class="search_wrapper">

            <el-date-picker @change="queryTableData" v-model="searchForm.timePic" type="daterange" range-separator="-"
                start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>

            <el-button type="primary" @click="searchBtn">
                查询
                <template #icon>
                    <SearchOutlined />
                </template>
            </el-button>

            <el-button @click="resetBtn"> 重置 </el-button>


        </div>
        <div class="content_wrapper">
            <a-row :gutter="[10, 10]">
                <!-- <a-col :span="24" :xs="24" :md="24" :lg="24" :xl="12" :xxl="12">
                    <FrameWrapper title="各区县走访的项目">
                        <template slot="contentSlot">
                            <VisitProjectCounty />
                        </template>
                    </FrameWrapper>
                </a-col> -->
                <a-col :span="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                    <FrameWrapper title="各类型单位走访的项目">
                        <template slot="contentSlot">
                            <VisitProjectUnit :dataInfo="dataInfo" ref="visitProjectUnitRef" />
                        </template>
                    </FrameWrapper>

                </a-col>
            </a-row>
        </div>
    </div>
</template>
<script>
import components from "./modular";
import FrameWrapper from "@/components/frame/zsFrame"
import * as api from "@/api/zs/zs"
import moment from "moment"
let searchFormData = {
    search: '',
    timePic: []
};
export default {
    name: 'visitStatistical',
    data() {
        return {
            loading: false,
            searchForm: Object.assign({}, searchFormData),
            dataInfo:{}
        }
    },
    components: {
        FrameWrapper,
        ...components
    },
    async mounted() {
        this.getVisitStatistic(true)


    },
    methods: {
        changeDate(){
           let params={
            visitDateBegin: this.searchForm.timePic.length>0
                ? moment(this.searchForm.timePic[0]).format("YYYY-MM-DD")
                : undefined,
                visitDateEnd: this.searchForm.timePic.length>0
                ? moment(this.searchForm.timePic[1]).format("YYYY-MM-DD")
                : undefined,
           } 
           this.getProjectStatistic(false,params)
        },

        async getVisitStatistic(isFirst,params){
            let that = this
            // this.loading = this.$loading({
            //     lock: true,
            //     text: "Loading",
            //     spinner: "el-icon-loading",
            //     background: "#ffffff",
            // });
            let res = await api.getVisitStatistic(params).catch(() => {
                // this.loading.close();
            });
            if (res.data.code == 200) {
                // that.loading.close();
                that.dataInfo = res.data.data

                if(isFirst){
                    that.$refs.visitProjectUnitRef.initChart()
                   
                }else {
                    that.$refs.visitProjectUnitRef.updateChart()
                    
                }
                


            }
        },
        // 重置
        resetBtn() {
            this.searchForm = Object.assign({}, searchFormData)
            this.getVisitStatistic(false)
        }
    },
}
</script>

<style lang="scss">
.project_statistical {
    padding: 0px !important;

    .search_wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 60px;
        line-height: 60px;
        background-color: #fff;
        margin-bottom: 10px;
        padding:0 20px;
        button {
            margin-left:20px;
        }
    }
    .content_wrapper {
        .frame {
            background-color: #fff;

            .title {
                padding-left: 20px;
            }
        }
    }
    

}</style>